import axios from 'axios';

export default function getCountries({ locale = 'en', signal } = {}) {
	const qs = new URLSearchParams({
		language: locale,
	}).toString();

	return axios
		.get(`/alt/apps/fshr/feeds/booking/countries?${qs}`, {
			signal,
			withCredentials: true,
		})
		.then(response => response.data.countries)
		.catch(error => {
			if (!axios.isCancel(error)) {
				throw error;
			}
		});
}
